import NiceModal from '@ebay/nice-modal-react';

import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';
import ProgressWizard from 'components/field/ProgressWizard';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useModalRouter from 'hooks/useModalRouter';

import { faList, faMemoCircleInfo, faShippingFast } from '@fortawesome/pro-solid-svg-icons';

import CreateShipmentWithMyRatesForm from './CreateShipmentWithMyRatesForm';
import ReturnDetails from './ReturnDetails';

const CreateReturnShipmentWithMyRates = NiceModal.create(({ id, modalName }) => {
	const { t } = useTranslation();
	const [tab, setTab] = useState(0);
	const { closeModal } = useModalRouter();
	const [orderID, setOrderID] = useState(null);
	const [returnDetailsRef, setReturnDetailsRef] = useState(null);
	const [createShipmentFormRef, setCreateShipmentFormRef] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [isAllShipmentsCreated, setIsAllShipmentsCreated] = useState(false);

	const ids = useMemo(() => [id], [id]);

	const handleCloseModal = () => {
		closeModal();
	};

	const nextStep = () => {
		if (tab < 1) {
			setTab(tab + 1);
		}
	};

	const prevStep = () => {
		if (tab > 0) {
			setTab(tab - 1);
		}
	};

	return (
		<Modal name={modalName} maxWidth="x-large" fullwidth className="modal-createReturnShipmentWithMyRates">
			<ModalTitle>
				<Typography variant="p1">
					{t('createReturnShipment')} <b>{orderID ? ` (${orderID})` : ''}</b>
				</Typography>
			</ModalTitle>
			<ModalContent>
				<ProgressWizard
					stages={[
						{ name: 'returnDetails', icon: faMemoCircleInfo },
						{ name: 'shippingOptions', icon: faList }
					]}
					setIndex={setTab}
					index={tab}
				/>
				{tab === 0 && (
					<ReturnDetails ref={setReturnDetailsRef} id={id} nextStep={nextStep} setOrderID={setOrderID} />
				)}
				{tab === 1 && (
					<CreateShipmentWithMyRatesForm
						ref={setCreateShipmentFormRef}
						ids={ids}
						setIsAllShipmentsCreated={setIsAllShipmentsCreated}
						isReturnShipment
					/>
				)}
			</ModalContent>
			<ModalActions>
				{tab === 0 && <Button label="cancel" variant="outline" onClick={handleCloseModal} />}
				{tab === 0 && (
					<Button
						label="showShippingOptions"
						icon={faShippingFast}
						variant="blue"
						onClick={async () => {
							setIsLoading(true);
							await returnDetailsRef.save();
							setIsLoading(false);
						}}
						loading={isLoading}
					/>
				)}
				{tab === 1 && !isAllShipmentsCreated && (
					<Button variant="outline" label="previous" onClick={prevStep} />
				)}
				{tab === 1 && !isAllShipmentsCreated && (
					<Button
						label="createShipment"
						onClick={async () => {
							setIsLoading(true);
							await createShipmentFormRef.handleCreateShipment();
							setIsLoading(false);
						}}
						loading={isLoading}
					/>
				)}
			</ModalActions>
		</Modal>
	);
});

export default CreateReturnShipmentWithMyRates;
